import React, { Component } from "react";
import PropTypes from "prop-types";
import { NIL } from "uuid";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  Label,
  Row,
  Input,
  Form,
} from "reactstrap";

export class SendNotificationModalForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      body: "",

      submitted: false,
    };
  }

  onOpened = () => {
    this.setState({
      title: "",
      body: "",
      submitted: false,
    });
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { userId } = this.props;
    const { title, body } = this.state;

    this.setState({
      submitted: true,
    });

    if (title && body) {
      const data = {
        title,
        body,
        userId,
      };

      this.props.onSubmit(data);
    }
  };

  render() {
    const { isOpen, toggle, title } = this.props;
    const { submitted } = this.state;
    return (
      <Modal
        size="md"
        onOpened={this.onOpened}
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {title}
          </h5>
          <button
            type="button"
            onClick={toggle}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          <Row>
            <Col md={12}>
              <FormGroup className="mb-3">
                <Label>Title</Label>
                <Input
                  type="text"
                  name="title"
                  placeholder="Title"
                  className={submitted && !this.state.title ? "is-invalid" : ""}
                  value={this.state.title}
                  onChange={this.handleChange}
                />
                {submitted && !this.state.title && (
                  <div className="invalid-feedback-custom">
                    Title is required.
                  </div>
                )}
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>Body</Label>
                <Input
                  type="textarea"
                  name="body"
                  rows={5}
                  placeholder="Body"
                  className={submitted && !this.state.body ? "is-invalid" : ""}
                  value={this.state.body}
                  onChange={this.handleChange}
                />
                {submitted && !this.state.body && (
                  <div className="invalid-feedback-custom">
                    Body is required.
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <Button color="primary" onClick={this.handleSubmit} type="submit">
            Submit
          </Button>
          <button
            type="button"
            onClick={toggle}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </Modal>
    );
  }
}

SendNotificationModalForm.propTypes = {
  item: PropTypes.object,
  title: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
  userId: PropTypes.string,
};

export default SendNotificationModalForm;
